<ng-container *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-toast *ngIf="!!edit.errormessage" ttType="danger" ttTitle="error" [ttMessage]="edit.errormessage" ttTranslateMessage="false"></tt-toast>

            <tt-tabs [(ttSelectedId)]="selectedBgMainView">
                <tt-tab ttId="INVOICELINE" ttLabel="invoicehead_invoiceline"></tt-tab>
                <tt-tab ttId="INVOICEHEAD" ttLabel="invoicehead_invoicehead"></tt-tab>
                <tt-tab ttId="FUNCTIONS" ttLabel="invoicehead_functions"></tt-tab>
            </tt-tabs>

            <div [hidden]="selectedBgMainView !== 'INVOICEHEAD'">
                <tt-tabs [(ttSelectedId)]="selectedBgTerms">
                    <tt-tab ttId="ADDRESS" ttLabel="invoicehead_address"></tt-tab>
                    <tt-tab ttId="TERMS" ttLabel="invoicehead_terms"></tt-tab>
                    <tt-tab ttId="STAT" ttLabel="invoicehead_stat"></tt-tab>
                </tt-tabs>

                <div [hidden]="selectedBgTerms !== 'ADDRESS'">
                    <tt-tabs [(ttSelectedId)]="selectedBgDelivery">
                        <tt-tab ttId="ADRSTAT" ttLabel="invoicehead_stat_address"></tt-tab>
                        <tt-tab ttId="ADRDEL" ttLabel="invoicehead_delivery_address"></tt-tab>
                        <tt-tab ttId="ADRINV" ttLabel="invoicehead_invoice_address"></tt-tab>
                    </tt-tabs>

                    <div [hidden]="selectedBgDelivery !== 'ADRSTAT'">
                        <ng-container *ngTemplateOutlet="addressCustomer"></ng-container>
                    </div>

                    <div [hidden]="selectedBgDelivery !== 'ADRDEL'">
                        <ng-container *ngTemplateOutlet="addressDelivery"></ng-container>
                    </div>

                    <div [hidden]="selectedBgDelivery !== 'ADRINV'">
                        <ng-container *ngTemplateOutlet="addressInvoice"></ng-container>
                    </div>
                </div>

                <div [hidden]="selectedBgTerms !== 'TERMS'">
                    <ng-container *ngTemplateOutlet="terms"></ng-container>
                </div>

                <div [hidden]="selectedBgTerms !== 'STAT'">
                    <ng-container *ngTemplateOutlet="statistics"></ng-container>
                </div>

                <tt-button-save ttText="invoicehead_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            </div>

            <div [hidden]="selectedBgMainView !== 'FUNCTIONS'">
                <ng-container *ngTemplateOutlet="buttonFunctions"></ng-container>
            </div>
        </tt-card>

        <tt-list-legacy [hidden]="selectedBgMainView !== 'INVOICELINE'" [listItems]="itemsListInvoiceLines" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-tabs [(ttSelectedId)]="selectedBgMainView">
            <tt-tab ttId="INVOICELINE" ttLabel="invoicehead_invoiceline"></tt-tab>
            <tt-tab ttId="INVOICEHEAD" ttLabel="invoicehead_invoicehead"></tt-tab>
        </tt-tabs>

        <tt-toast *ngIf="!!edit.errormessage" ttType="danger" ttTitle="error" [ttMessage]="edit.errormessage" ttTranslateMessage="false"></tt-toast>

        <tt-grid [hidden]="selectedBgMainView !== 'INVOICELINE'" *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>

        <div class="tt-invoicehead__edit" [hidden]="selectedBgMainView !== 'INVOICEHEAD'">
            <div>
                <tt-card ttHeading="invoicehead_invoice_address">
                    <ng-container *ngTemplateOutlet="addressInvoice"></ng-container>
                </tt-card>
                <tt-card ttHeading="invoicehead_delivery_address">
                    <ng-container *ngTemplateOutlet="addressDelivery"></ng-container>
                </tt-card>
                <tt-card ttHeading="invoicehead_stat_address">
                    <ng-container *ngTemplateOutlet="addressCustomer"></ng-container>
                </tt-card>
            </div>

            <div>
                <tt-card ttHeading="invoicehead_terms">
                    <ng-container *ngTemplateOutlet="terms"></ng-container>
                </tt-card>
                <tt-card ttHeading="invoicehead_stat">
                    <ng-container *ngTemplateOutlet="statistics"></ng-container>
                </tt-card>
            </div>

            <div>
                <tt-card ttHeading="invoicehead_functions">
                    <ng-container *ngTemplateOutlet="buttonFunctions"></ng-container>
                </tt-card>

                <tt-card>
                    <tt-button-save ttText="invoicehead_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
                </tt-card>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-template #addressCustomer>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="stat_cust_no" [ttModel]="edit.stat_cust_no" [ttButtons]="statCustNoButtons" ttReadonly></tt-input>
        <tt-input ttLabel="stat_cust_name" [ttModel]="edit.stat_cust_name" ttReadonly></tt-input>
        <tt-textarea ttLabel="stat_cust_address" [(ttModel)]="edit.stat_cust_address"></tt-textarea>
        <tt-input ttLabel="customers_ref1" [(ttModel)]="edit.customers_ref1"></tt-input>
        <tt-input ttLabel="customers_ref2" [(ttModel)]="edit.customers_ref2"></tt-input>
        <tt-input ttLabel="customers_orderno" [(ttModel)]="edit.customers_orderno"></tt-input>
    </ng-container>
</ng-template>

<ng-template #addressDelivery>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="delivery_cust_no" [ttModel]="edit.delivery_cust_no" [ttButtons]="deliveryCustNoButtons" ttReadonly></tt-input>
        <tt-input ttLabel="delivery_cust_name" [ttModel]="edit.delivery_cust_name" ttReadonly></tt-input>
        <tt-input ttLabel="delivery_cust_address" [ttModel]="edit.delivery_cust_address" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #addressInvoice>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="invoice_cust_no" [ttModel]="edit.invoice_cust_no" [ttButtons]="invoiceCustNoButtons" ttReadonly></tt-input>
        <tt-input ttLabel="invoice_cust_name" [ttModel]="edit.invoice_cust_name" ttReadonly></tt-input>
        <tt-textarea ttLabel="invoice_cust_address" [ttModel]="edit.invoice_cust_address" ttReadonly></tt-textarea>
    </ng-container>
</ng-template>

<ng-template #terms>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="invoice_valuta_id" [ttModel]="edit.invoice_valuta_id" ttReadonly></tt-input>
        <tt-select ttLabel="payment" [(ttModel)]="edit.payment_id" [ttData]="selectListPayments" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-select ttLabel="factoring" [(ttModel)]="edit.factoring_no" [ttData]="selectListFactorings" ttDataId="item_id" ttDataName="item_name"></tt-select>
    </ng-container>
</ng-template>

<ng-template #statistics>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="project_keyno" [ttModel]="edit.project_keyno" ttReadonly></tt-input>
        <tt-search
            ttLabel="project_name"
            [(ttModel)]="edit.project_name"
            [ttSearch]="searchProjectNames"
            (ttOnSelected)="onProjectNameSelected($event)"
            (ttOnClear)="onProjectNameSelected()"
        ></tt-search>
        <tt-select ttLabel="department" [(ttModel)]="edit.department_id" [ttData]="selectListDepartments" ttDataId="department_id" ttDataName="department_name"></tt-select>
        <tt-input ttLabel="businessco_companyname" [ttModel]="edit.businessco_companyname" ttReadonly></tt-input>
        <tt-input ttLabel="invoice_no" [ttModel]="edit.invoice_no" ttReadonly></tt-input>
        <tt-input ttLabel="invoice_no2" [ttModel]="edit.invoice_no2" ttReadonly></tt-input>
        <tt-date ttLabel="invoice_date" [ttModel]="edit.invoice_date" ttReadonly></tt-date>
        <tt-input ttLabel="reg_by_user_name" [ttModel]="edit.reg_by_user_name" ttReadonly></tt-input>
        <tt-date ttLabel="payment_date" [(ttModel)]="edit.payment_date"></tt-date>
        <tt-checkbox ttLabel="printed_ok" [(ttModel)]="edit.printed_ok"></tt-checkbox>
        <tt-button [hidden]="edit.printed_ok !== '0'" ttText="invoicehead_set_printed_ok" (ttClick)="setPrintedOk()" [ttSpin]="printingOk" ttIcon="glyphicon glyphicon-check"></tt-button>
    </ng-container>
</ng-template>

<ng-template #buttonFunctions>
    <ng-container *ngIf="!!edit">
        <tt-button-goto [ttText]="'invoicehead_print'" [ttGoto]="'selectreport'" [ttGotoParms]="{ webpage_name: webPageName, argtype: 'invoice_no', argvalue: edit.invoice_no }"></tt-button-goto>
        <tt-button-goto *ngIf="edit.show_ehf === '1'" [ttText]="'invoicehead_ehf_make'" [ttGoto]="'invoiceheadehf'" [ttGotoParms]="{ invoice_no: edit.invoice_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="edit.show_documents === '1'"
            [ttText]="'invoicehead_documents'"
            [ttBadge]="edit.nbr_of_documents"
            [ttGoto]="'documents'"
            [ttGotoParms]="{ argtype: 'invoice_no', argvalue: edit.invoice_no }"
        ></tt-button-goto>
        <tt-button-goto [ttText]="'invoicehead_sendmail'" [ttGoto]="'emailcreate'" [ttGotoParms]="{ webpage: webPageName, argtype: 'invoice_no', argvalue: edit.invoice_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="edit.show_tracesearch === '1'"
            [ttText]="'invoicehead_tracesearch'"
            [ttGoto]="'tracesearch'"
            [ttGotoParms]="{ argtype: 'invoice_no', argvalue: edit.invoice_no }"
        ></tt-button-goto>
        <tt-button ttText="invoicehead_send_edi_invoice" (ttClick)="sendChanges()" [ttSpin]="sendingInvoice" ttIcon="fa fa-paper-plane"></tt-button>
    </ng-container>
</ng-template>
